<template>
  <div class="home">
    <Intro />
    <Articles />
    <Videos />
    <Contact />
  </div>
</template>

<script>
import Intro from "@/components/home/Intro";
import Articles from "@/components/home/Articles";
import Videos from "@/components/home/Videos";
import Contact from "@/components/home/Contact";
export default {
  name: "Home",
  components: { Intro, Articles, Videos, Contact }
};
</script>
